import { useEffect, useState, useRef } from 'react';
import { deviceDetect, getUA } from 'react-device-detect';
import { useLocation } from 'react-router';
import { MarketingEventLogAPIService } from './api-service';
import { Cookies } from "react-cookie-consent";

const useScript = (ip) => {
    const [deviceDetails,] = useState({ ...deviceDetect(getUA) });
    const location = useLocation();
    const scriptsLoadedRef = useRef(false);

    // Load scripts only once on mount
    useEffect(() => {
        if (scriptsLoadedRef.current) return;
        
        if (Cookies.get("dataconnectorcookie") === 'true') {
            // Skip third-party pixels locally: ad blockers cause ERR_BLOCKED_BY_CLIENT noise
            if (process.env.NODE_ENV === 'development') {
                scriptsLoadedRef.current = true;
                return;
            }
            // LinkedIn - only initialize once
            if (!window.lintrk) {
                const _linkedin_partner_id = "4960033";
                window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
                window._linkedin_data_partner_ids.push(_linkedin_partner_id);

                window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
                window.lintrk.q = [];

                // Only add LinkedIn script if it doesn't exist
                if (!document.querySelector('script[src*="snap.licdn.com"]')) {
                    var s = document.getElementsByTagName("script")[0];
                    var b = document.createElement("script");
                    b.type = "text/javascript";
                    b.async = true;
                    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
                    s.parentNode.insertBefore(b, s);
                }
            }
            
            scriptsLoadedRef.current = true;
        }
    }, []); // Only run once on mount

    // Track route changes separately (non-blocking)
    useEffect(() => {
        if (ip) {
            // Make API call non-blocking - don't await it
            MarketingEventLogAPIService.addMarketingEventLog({
                IPAddressTxt: ip,
                DeviceDsc: deviceDetails.isMobile ? `${deviceDetails.vendor} ${deviceDetails.model}` : `${deviceDetails.browserName} ${deviceDetails.osName}`,
                EventLogTypeDsc: "Navigation",
                EventLogDsc: `Visited url route.`,
                EventPageUrlTxt: location.pathname + location.search + location.hash,
                DeviceDimensionsTxt: `${window.innerWidth}X${window.innerHeight}`,
            }).catch((err) => {
                // Silently fail - don't block navigation
                if (process.env.NODE_ENV === 'development' && err?.response?.status >= 400) {
                    return;
                }
                console.error('Failed to log navigation event:', err);
            });
        }
    }, [ip, location.pathname, location.hash, location.search, deviceDetails]);
};

export default useScript;



